function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2763 13.1254L44.4476 4.56812C51.7345 2.68829 59.4426 3.32369 66.3233 6.37139L101.394 21.9054C102.398 22.3499 103.335 22.9301 104.181 23.6298C109.685 28.1853 110.004 36.5156 104.864 41.4786L95.612 50.4114C91.2346 54.6379 85.3874 57 79.3026 57H12.0614C6.45074 57 3.31611 50.5253 6.79604 46.1242C10.3246 41.6616 10.4586 35.3979 7.12414 30.7885L5.64519 28.7441C1.49562 23.0079 4.42102 14.8939 11.2763 13.1254Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgOffroad1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 60,
    viewBox: "0 0 112 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffroad1);
export default __webpack_public_path__ + "static/media/offroad1.2f1bbd49.svg";
export { ForwardRef as ReactComponent };